var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useForm } from '@isyc-react/form/modules/rhf';
import { consentsGroupToConsentsGroupValue, RhfInputConsentsGroupList, } from '@isyc-react/oncustomer/modules/objects/consent';
import { DossierStep, useDossierContext, useDossierUpdateOrchestration } from 'common-app/dossier';
import { useTranslation } from 'react-i18next';
import { namespaces } from 'i18n/i18n.constants';
import { ConsentGroupStatus, useConsentGroupUpdateStatusMutationPromise, useConsentParamsUpdateMutationPromise, } from '@isyc-react/oc-api/queries/consents';
import { useErrorNotification } from '@isyc-react/form/modules/context';
export const ConsentsGroupForm = props => {
    const { dossier } = useDossierContext();
    const { consentsGroup } = props;
    const { t } = useTranslation(namespaces.common);
    const [loading, setLoading] = React.useState(false);
    const { control, formState, handleSubmit } = useForm({
        mode: 'onTouched',
        defaultValues: {
            consentsGroup: consentsGroup.map(cg => consentsGroupToConsentsGroupValue(cg)),
        },
    });
    const { isValid } = formState;
    const [updateStep, { loading: loadingOrchestation }] = useDossierUpdateOrchestration();
    const consentParamsUpdate = useConsentParamsUpdateMutationPromise();
    const consentsGroupUpdateStatus = useConsentGroupUpdateStatusMutationPromise();
    const addErrorNotification = useErrorNotification();
    const onFormSuccess = (values) => __awaiter(void 0, void 0, void 0, function* () {
        const { consentsGroup } = values;
        setLoading(true);
        const promises = [];
        consentsGroup.forEach(cg => {
            cg.consents.forEach(c => {
                if (c.parameters.length > 0) {
                    promises.push(consentParamsUpdate({
                        id: c.id,
                        parameterList: c.parameters.map(p => ({
                            id: p.id,
                            code: p.code,
                            value: p.value,
                            remarks: p.remarks,
                        })),
                    }));
                }
            });
        });
        // TODO ADD NOTIFICATION HUB FOR ERRORS??
        yield Promise.all(promises);
        const groupPromises = [];
        consentsGroup.forEach(cg => {
            groupPromises.push(consentsGroupUpdateStatus({
                id: cg.id,
                status: {
                    treelevel1: ConsentGroupStatus.TO_VALIDATE,
                },
            }));
        });
        yield Promise.all(groupPromises)
            .catch(err => {
            addErrorNotification('Une erreur est survenue lors de la mise à jour du statut du groupe de consentements', {
                life: 5000,
            });
            console.error('Error', err);
        })
            .then(() => {
            updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.SIGNATORIES } }).finally(() => {
                setLoading(false);
            });
        });
    });
    const onFormError = values => {
        addErrorNotification('Tous les champs obligatoires ne sont pas correctement renseignés', { life: 10000 });
    };
    // TODO i18n
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: handleSubmit(onFormSuccess, onFormError) },
            React.createElement("div", { className: 'd-flex flex-column align-items-center justify-content-center' },
                React.createElement("div", null,
                    React.createElement(RhfInputConsentsGroupList, { rhf: { control, name: 'consentsGroup' }, input: { data: consentsGroup } })),
                React.createElement("button", { type: 'submit', className: 'btn btn-secondary btn-lg mt-4 btn-pill px-5 fw-500', disabled: !isValid || loading || loadingOrchestation, "aria-label": '', "aria-describedby": '' }, "J'accepte")))));
};
